
import {map, startWith} from 'rxjs/operators';
import { Component, OnInit,  EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators} from '@angular/forms';
import {SubmitterDetails, LegalEntityDetail, countries, Contact} from "../model/lei-model";
import { Observable } from 'rxjs';




@Component({
  selector: 'app-lei-contact',
  templateUrl: './lei-contact.component.html',
  styleUrls: ['./lei-contact.component.scss']
})
export class LeiContactComponent implements OnInit {

  @Input() contact: Contact;
  @Input() index: number;
  @Input() last: number;
  @Input() defaultName : string;
  @Input() defaultMail : string;

  @Output() contactValid: EventEmitter<boolean> = new EventEmitter();

  contactNameFormControl : FormControl;
  contactEmailFormControl : FormControl;
  contactLocationFormControl : FormControl;
  contactJobFormControl : FormControl;

  private countries = countries;
  invoiceCountries: Observable<any>;

  @Output() addContactToModel: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {

    let EMAIL_REGEX = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;

    this.contactNameFormControl = new FormControl('', [
      Validators.required]);

    this.contactEmailFormControl = new FormControl('', [
      Validators.required,  Validators.pattern(EMAIL_REGEX)]);

    this.contactLocationFormControl = new FormControl('', [
      Validators.required]);

    this.contactJobFormControl = new FormControl('', [
      Validators.required]);


    this.invoiceCountries = this.contactLocationFormControl.valueChanges.pipe(
      startWith(null),
      map(val => val ? this.filter(val) : this.countries.slice()),);

    this.contact.name = this.defaultName;
    this.contact.email = this.defaultMail;
  }

  filter(val: string): string[] {
    return this.countries.filter(country =>
    country.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }


  private addAnotherContact(event){
    this.addContactToModel.emit();
  }

  setValidityOfContact() {
    if(this.contactNameFormControl.valid && this.contactEmailFormControl.valid && this.contactLocationFormControl.valid && this.contactJobFormControl.valid)
      this.contactValid.emit(true);
    else
      this.contactValid.emit(false);
  }


}
